/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc
 */
import * as References from './HubSpotVideoSearchRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoSearchRpc_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['count', 'offset', 'filterGroups', 'sorts'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#advancedSearch
 */
export const ADVANCED_SEARCH_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoSearchRpc_advancedSearch';
export const ADVANCED_SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ADVANCED_SEARCH_QUERY_FIELD_NAME,
  args: ['fileId', 'query', 'topK', 'searchType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.advancedSearchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#advancedSearchWithVideosHydrated
 */
export const ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoSearchRpc_advancedSearchWithVideosHydrated';
export const ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY_FIELD_NAME,
  args: ['fileId', 'query', 'topK', 'searchType'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.advancedSearchWithVideosHydratedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#getEmbeddedVectorsForVideo
 */
export const GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoSearchRpc_getEmbeddedVectorsForVideo';
export const GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getEmbeddedVectorsForVideoRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#reprocessVideosForVisualSearch
 */
export const REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoSearchRpc_reprocessVideosForVisualSearch';
export const REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION_FIELD_NAME,
  args: ['fileIds'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.reprocessVideosForVisualSearchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});